var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "date-locale-picker" }, [
    _c("div", { staticClass: "search-panel" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.search,
            expression: "search",
          },
        ],
        attrs: {
          maxlength: "128",
          placeholder: _vm.$t("chatbotv2.typeSearchValue"),
          type: "text",
        },
        domProps: { value: _vm.search },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.search = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "material-icons" }, [_vm._v(" search ")]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "entity-list" }, [
      _c(
        "div",
        { staticClass: "entity-select" },
        [
          _c("div", { staticClass: "text-uppercase caption" }, [
            _vm._v(_vm._s(_vm.$t("auto.dateLocalePickerLocales"))),
          ]),
          _vm._v(" "),
          _vm._l(_vm.getFilteredItems(), function (item) {
            return _c(
              "div",
              {
                staticClass: "picker-item",
                class: { active: _vm.value === item.value },
                on: {
                  click: function ($event) {
                    return _vm.pick(item.value)
                  },
                },
              },
              [
                _c("span", { staticClass: "name" }, [
                  _vm._v(_vm._s(item.description) + " "),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "description" }, [
                  _vm._v(_vm._s(item.example)),
                ]),
              ]
            )
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }